<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { Youtube } from 'src/modules/youtube_module.js'
import { get } from "lodash";
import { kenwoodItalyBasicMixin } from "../../modules/kenwood_italy_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, kenwoodItalyBasicMixin],
  props: {
    customShareSlug: {
      type: String,
      default: ""
    },
    animation: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {
    Vue.nextTick(() => {
      // Animation management.
      if (this.animation) {
        this.registerAnimation();
      }
      // Video autoplay management.
      if (this.isContentVisibleToUser()) {
        $(this.$refs["video"]).on('inview', (event, isInView) => {
          if (isInView) {
            $(event.target).find('video').each(function(i, video) {
              video.muted = true; // Muted attribute seems to not be parsed correctly by vue.
              video.play();
            });
          } else {
            $(event.target).find('video').each(function(i, video) {
              video.pause();
            });
          }
        });
      }
    });
  },
  methods: {
    getBackgroundUrl: Fandom.getBackgroundUrl,
    toggleYoutubePopup: Youtube.toggleYoutubePopup,
    mayToggleYoutubePopup() {
      if (this.isYoutubePresent) {
        this.toggleYoutubePopup();
      }
    },
  },
  computed: {
    isYoutubePresent() {
      const mediaType = get(this.content, ["play", "media_type"], false);
      return mediaType == "youtube";
    },
    aspectRatioClasses: function() {
      return [
        (Fandom.exists(this.content.height) && this.content.height.indexOf("$") === 0) ? this.content.height.replace("$", "ar-") : "ar-16by9",
      ];
    },
    contentClasses: function() {
      const classes = [];

      if (this.content.boxed) {
        classes.push("inset");
      }

      classes.push(this.content.theme ? `${this.content.theme}-theme` : "");

      // Height management. Default 100vh.
      if (!Fandom.exists(this.content.height)) {
        classes.push("mh-100vh-header-sm");
      }

      // Mobile reverse management. Default image and text
      if ((globalState.viewport.sm || globalState.viewport.xs) && this.content.reverse_mobile) {
        classes.push("flex-column-reverse");
      } else if (this.content.reverse) {
        classes.push("flex-row-reverse");
      }

      return classes;
    },
    contentStyle: function() {
      let style = { };
      if (globalState.viewport.md || globalState.viewport.lg || globalState.viewport.xl) {
        style["min-height"] = (Fandom.exists(this.content.height) && this.content.height.indexOf("$") !== 0) ? this.content.height : null;
      }
      if (!this.content.theme) {
        style["background-color"] = this.content.background_color ? this.content.background_color : "inherit";
        style["color"] = this.content.text_color ? this.content.text_color : "inherit";
      }
      return style;
    },
    mediaColumnClasses: function() {
      const classes = [];

      // d-md-block preserve image column from md breakpoint.
      if (!Fandom.exists(this.content.image) && !Fandom.exists(this.content.video)) {
        classes.push("d-none d-lg-flex")
      } else {
        classes.push("d-flex");
      }

      if (Fandom.exists(this.content.text_column_width)) {
        classes.push("col-lg-" + (12 - parseInt(this.content.text_column_width)));
      } else {
        classes.push("col-lg-6");
      }

      if (this.content.play) {
        classes.push("cursor-pointer");
      }

      return classes;
    },
    textColumnClasses: function() {
      const classes = [];
      classes.push(Fandom.exists(this.content.text_column_width) ? "col-lg-" + this.content.text_column_width : "col-lg-6");
      return classes;
    }
  },
};
</script>

<template>
  <div v-easyadmin="easyadminId" class="position-relative" :style="{'background-color': content.outer_background_color && content.background_color}" :class="[paddingY, contentType, {'inview_animate': animation}]" v-if="isContentVisibleToUser()" two-col-component>
    <div
      class="row m-0 w-100 h-100 position-absolute-center bg-cover-center inview_animate_zoom"
      v-if="content.background_image && content.propagate_background"
      :style="{'background-image': getContentResponsiveImageURL('background_image')}"
    ></div>
    <div class="container position-relative overflow-hidden">
      <div
        class="row m-0 w-100 h-100 position-absolute-center bg-cover-center inview_animate_zoom"
        v-if="content.background_image && !content.propagate_background"
        :style="{'background-image': getContentResponsiveImageURL('background_image')}"
      ></div>
      <div class="position-absolute-center w-100 h-100 layer" v-if="content.background_image"></div>
      <div class="row google-seo-height" :class="contentClasses" :style="contentStyle">
        <div class="col-12 p-0 media-column" :class="mediaColumnClasses" @click="mayToggleYoutubePopup()">
          <div v-if="content.video" :class="aspectRatioClasses" ref="video">
            <div class="video-1by1 position-absolute-center">
              <video loop webkit-playsinline playsinline>
                <source :src="content.video.url" type="video/mp4">
              </video>
            </div>
          </div>
          <div class="bg-cover-center w-100 position-relative" v-if="content.image" :title="content.image.alt" :style="{'background-image': getContentResponsiveImageURL('image')}" :class="aspectRatioClasses">
            <span class="position-absolute-center d-flex flex-column justify-content-center align-items-center" v-if="isYoutubePresent">
              <i class="far fa-play-circle"></i>
            </span>
          </div>
        </div>
        <div class="col-12 d-flex flex-column justify-content-center py-4 text-column" :class="textColumnClasses">
          <div class="row justify-content-center">
            <div class="col-sm-10 px-4">
              <div stripe-header v-if="content.title_composed">
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-center">
                      <span class="text-uppercase px-2 py-1 font-sm d-flex text-white mb-3" :class="`bg-${color}`" v-if="content.category">
                        {{content.category}}
                      </span>
                    </div>
                    <component class="title-composed" :is="content.title_tag || 'h2'" v-if="content.title">
                      {{content.title}}
                    </component>
                    <component class="title-composed" :is="content.title_tag || 'h2'" v-else>
                      <span v-for="title in content.title_composed" :class="getTitleStyle(title)" :key="title.$id">
                        {{title.title}}
                      </span>
                    </component>
                  </div>
                </div>
              </div>
              <text-section :content="content" :opt-container-content="containerContent" :custom-share-slug="customShareSlug"></text-section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[two-col-component] {
  height: auto;

  > div > .row.inset {
    padding: 5rem;
  }

  .far {
    font-size: 8rem;
  }

  /* Resetting min-height value makes images displayed with aspect ratio */
  @include media-breakpoint-down(lg) {
    .mh-100vh-header-sm {
      min-height: auto !important;
    }
  }

  @include media-breakpoint-down(sm) {
    .mh-100vh {
      min-height: auto !important;
    }
  }

  @include media-breakpoint-down(xs) {

    /* Forced square rappresentation */
    .ar-16by9,
    .ar-4by3 {
      padding-bottom: 100%;
      min-width: 1px;
    }

    > div > .row.inset {
      padding: 0;
    }
  }

  /* IE11 hack */
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {

    > div > .row {
      max-height: 1080px;
    }

    .media-column,
    .text-column {
      min-height: inherit;
      max-height: 1080px;
    }
  }

  [text-section-component] {
    .btn {
      padding: 1rem 3rem;
    }

    @include media-breakpoint-down(sm) {
      .description {
        h1 {
          font-size: 2.125rem;
        }
      }
    }
  }
}
</style>
